import i18n from 'i18n-js'
import en from 'localizations/en.js'
import es from 'localizations/es.js'
import es_ES from 'localizations/es-ES.js'
import fr from 'localizations/fr.js'
import pt from 'localizations/pt.js'
import it from 'localizations/it.js'
import de from 'localizations/de.js'
import ja from 'localizations/ja.js'
import zh from 'localizations/zh.js'
import { TranslateOptions } from 'i18n-js'
import { LOCALE } from 'src/Common/Constant'

type LocalizationCategory = 'TITLE' | 'BUTTON' | 'LABEL'

type LocalizationOptions = {
  identifier?: String
  pluralized?: Boolean
}

type StringContents = String | PluralizationContent

type PluralizationContent = {
  other: String
  zero: String
  one: String
}

// useLocalization(LocalizationCategory, LocalizationOptions)(StringContents, TranslateOptions)

i18n.translations = {
  en,
  'en-US': en,
  es,
  'es-ES': es_ES,
  pt,
  'pt-BR': pt,
  fr,
  'fr-CA': fr,
  it,
  'it-IT': it,
  de,
  'de-DE': de,
  ja,
  'ja-JP': ja,
  zh,
  'zh-CN': zh,
}

const search = window.location.search
const params = new URLSearchParams(search)
const localeValue = params.get('locale')
localStorage.setItem(LOCALE, localeValue ? localeValue : 'en')
i18n.locale = localeValue ? localeValue : 'en'
i18n.fallbacks = true

export const localize = (
  category: LocalizationCategory,
  args1?: LocalizationOptions
) => (string: StringContents, args2?: TranslateOptions) => {
  let identifier = JSON.stringify(string).replace(/\./g, '##PERIOD##')
  let platformSuffix = ''
  return i18n
    .t(`${category}.${identifier}${platformSuffix}`, args2)
    .replace(/##PERIOD##/g, '.')
}
